// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"8681515a","408":"bda603bc","818":"2cdca161"}[chunkId] + ".chunk.js";
};